import React from 'lib/react';
import { useSelector } from 'lib/redux';
import { EVPaper } from 'lib/components';
import { isEntitledForSubscriptionDashboardSelector } from 'utils/appSelectors.utils';
import AccountsSummary from '../accountsSummary/AccountsSummary.component';
import CompanyInformationDisplay from '../companyInfo/CompanyInformationDisplay.component';
import AccountsSummaryLoader from '../accountsSummary/AccountsSummaryLoader';
import AccountsSummaryStyles from '../accountsSummary/AccountsSummaryStyles';
import SubscriptionDashboard from '../subscriptionDashboard/SubscriptionDashboard.component';

function AccountsSection() {
  const accSummaryClasses = AccountsSummaryStyles();

  const {
    companyInformationLoading,
    accountsSummaryLoading,
    subscriptionDashboardLoading,
  } = useSelector(({ userData }) => ({
    companyInformationLoading: userData.loading.companyInformation,
    accountsSummaryLoading: userData.loading.accountSummary,
    subscriptionDashboardLoading: userData.loading.subscriptionDashboard,
  }));

  const isEntitledForSubscriptionDashboard = useSelector(isEntitledForSubscriptionDashboardSelector);
  if (companyInformationLoading || accountsSummaryLoading || subscriptionDashboardLoading) {
    return <AccountsSummaryLoader />;
  }

  return (
    <EVPaper className={accSummaryClasses.accountsSummaryPaper}>
      <CompanyInformationDisplay />
      {isEntitledForSubscriptionDashboard ? <SubscriptionDashboard /> : <AccountsSummary />}
    </EVPaper>
  );
}

export default AccountsSection;
